export const APP_VERSION = process.env.REACT_APP_BUILD_VERSION || '0.1.5';